import { Button } from '@components/base';
import css from './index.module.scss';
import CarrierInfo from './components/carrier-info';
import FreightAndCharges from './components/freight-charges';
import Instructions from './components/instructions';
import { useFormContext } from 'react-hook-form';

interface InstructionAndChargesProps {
  handleInstructionAndCharges: () => void;
  handleCancelClick: () => void;
}

const InstructionAndCharges = (props: InstructionAndChargesProps) => {
  const { handleInstructionAndCharges, handleCancelClick } = props;
  const { handleSubmit } = useFormContext();
  return (
    <form
      noValidate
      onSubmit={handleSubmit(handleInstructionAndCharges)}
      className={css.mainWrapper}
    >
      <CarrierInfo />
      <FreightAndCharges />
      <Instructions />
      <div className={css.formActionWrapper}>
        <Button variant="text" onClick={handleCancelClick}>
          Cancel
        </Button>
        <Button type="submit">Save and Proceed</Button>
      </div>
    </form>
  );
};

export default InstructionAndCharges;
